import { useEffect, useRef } from "react";
import { useSettings } from "../contexts/SettingsContext";

// Idle snapback for pop-ups: close after the same idle time; App's screen timer holds while open.
export function useIdleClose(open, onClose) {
  const { settings } = useSettings();
  const secs = Number(settings?.idle_dashboard_snapback_seconds ?? 30);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    if (!open) return undefined;
    const IDLE_MS = Math.max(10, secs) * 1000;
    document.body.dataset.idleHold = "1";
    let timerId = null;
    const arm = () => {
      if (timerId) clearTimeout(timerId);
      if (document.hidden) return;
      timerId = setTimeout(() => {
        delete document.body.dataset.idleHold;
        onCloseRef.current();
        window.dispatchEvent(new Event("ureserve:idle-step"));
      }, IDLE_MS);
    };
    arm();
    // Capture phase so scrolling inside the pop-up (scroll doesn't bubble) counts as activity.
    const events = ["mousemove", "keydown", "click", "scroll", "wheel", "touchstart"];
    events.forEach((ev) => window.addEventListener(ev, arm, { passive: true, capture: true }));
    document.addEventListener("visibilitychange", arm);
    return () => {
      if (timerId) clearTimeout(timerId);
      delete document.body.dataset.idleHold;
      events.forEach((ev) => window.removeEventListener(ev, arm, { capture: true }));
      document.removeEventListener("visibilitychange", arm);
    };
  }, [open, secs]);
}
